import ArrowRightIcon from "~/assets/icons/ArrowRightIcon";
import { getCurrencyByFormatting } from "~/lib"
import useShopSettings from "~/rs-components/shop/useShopSettings";
import { ProductMetafields, ShopSettings, VariantEdgeMetafields } from "~/types"
import { isNonTransactional, showPriceshowPriceTransactional } from "../../../../setup/settings/__nonTransactional";
import { addToBasketButtonName } from "../../../../setup/settings/__cart";

type Props =
    {
        variant: VariantEdgeMetafields,
        product: ProductMetafields,
        shopSettings: ShopSettings,
        currency: string,
        clickClose: () => void,
        addVariantBasket: (variant: VariantEdgeMetafields) => void
    }

export default function VariantModal({ variant, product, shopSettings, currency, clickClose, addVariantBasket }: Props) {
    const { redPriceStock } = useShopSettings(shopSettings);
    const options = variant.node.options?.value != undefined && variant.node.options?.value != "[]" ?
        JSON.parse(variant.node?.options?.value) : [];

    const basePriceOptions = variant.node.basePriceOptions?.value != undefined && variant.node.basePriceOptions?.value != "[]" ?
        JSON.parse(variant.node?.basePriceOptions?.value)[0] : JSON.parse("{}");

    return (
        <div className="variant-modal">
            <span className="back" onClick={clickClose}><ArrowRightIcon /></span>
            <p className="titleProduct">{product.title}</p>
            {(!isNonTransactional || showPriceshowPriceTransactional) &&
                <p className={`${redPriceStock ? "ProductList__price-red" : "priceProduct"}`}>{getCurrencyByFormatting(currency)}{variant.node?.price.amount}</p>
            }
            {basePriceOptions != null && <p className="variant-option">{basePriceOptions.Value}</p>}
            <img className="variant-image " src={variant.node.image?.url}></img>
            {options.map((option: any) => (
                <div className="variant-option">
                    {option.Value != null && <p className="variant-option-title">{option.Value}</p>}
                    {option.Photo != null && <img className="variant-option-image" src={option.Photo}></img>}
                </div>
            ))}
            {(!isNonTransactional) &&
                <span className={`black-button`} onClick={() => addVariantBasket(variant)}>
                   {addToBasketButtonName.default? ' ADD TO BASKET' : addToBasketButtonName.name} - {getCurrencyByFormatting(currency)}{variant.node?.price.amount}
                </span>
            }
        </div>
    )
}